<section class="container">
    <div class="login-section">
        <div class="login-header">
            <img src="assets/icons/seller-logo.png" class="app-logo" alt="app-logo" />
        </div>
        <div class="welcome-part">
            <h4 class="welcome-title">نسيت كلمة المرور؟</h4>
            <p class="welcome-paragraph">أدخل بريدك الإلكتروني وسنرسل لك رابط إعادة تعيين كلمة المرور</p>
        </div>
        <div class="credentials-part col-md-6">
            <form [formGroup]="form" (ngSubmit)="sendResetLink()" *ngIf="!isSuccess">
                <!-- EMAIL -->
                <div class="d-flex flex-column gap-2 mb-3">
                    <label for="email">الايميل</label>
                    <input
                        formControlName="email"
                        autocomplete="off"
                        pInputText
                        id="email"
                        class="p-inputtext-sm"
                        aria-describedby="email-help" />
                </div>
                <div class="text-center my-2" [ngClass]="{'text-danger': !isSuccess, 'text-success': isSuccess}">
                    {{ message }}
                </div>
                <div class="submit-form full-width">
                    <p-button
                        [disabled]="form.invalid || resetInProgress"
                        type="submit"
                        label="إرسال رابط إعادة التعيين"
                        class="w-100"
                        [icon]="resetInProgress ? 'pi pi-spin pi-spinner' : ''"></p-button>
                </div>
            </form>
            
            <!-- SUCCESS MESSAGE -->
            <div *ngIf="isSuccess" class="text-center">
                <div class="text-center my-4">
                    <i class="pi pi-check-circle text-success" style="font-size: 3rem;"></i>
                </div>
                <div class="text-center my-2 text-success">
                    {{ message }}
                </div>
                <p class="text-muted">تحقق من بريدك الإلكتروني واتبع الرابط لإعادة تعيين كلمة المرور</p>
            </div>
            
            <!-- BACK TO LOGIN -->
            <div class="register-redirection">
                <small>تذكرت كلمة المرور؟ <a class="m-1 text-primary-600" routerLink="/auth/login">تسجيل الدخول</a></small>
            </div>
        </div>
    </div>
</section>
